<template>
  <div class="R0MLST9LrIm3TlgIs5ln">
    <div class="top-btn"></div>
    <div class="features">
      <div class="top-banner"><img src="/webx/xc/mobile/images/outcache/banner.8d72.png" alt=""
                                   class="barner"><img src="/webx/xc/mobile/images/outcache/top-title.3bcc.png" alt=""
                                                       class="top-title"></div>
      <div class="box">
        <div class="bg"><img src="/webx/xc/mobile/images/outcache/title01.df7f.png" alt="" class="title">
<!--          <iframe-->
<!--            class="exh" src="/webx/xc/mobile/images/outcache/ad2c3bb7-b809-473c-bae6-dd43c61fc83f.png"></iframe>-->
          <img
              src="/webx/xc/mobile/images/outcache/ad2c3bb7-b809-473c-bae6-dd43c61fc83f.png"
              class="responsive-img"
              style="max-width: 100%; height: auto; display: block;"
          >

          <ul class="imgs">
            <li><img src="/webx/xc/mobile/images/outcache/man1.1bbe.png" alt=""></li>
            <li><img src="/webx/xc/mobile/images/outcache/man2.8f27.png" alt=""></li>
            <li><img src="/webx/xc/mobile/images/outcache/man3.645a.png" alt=""></li>
          </ul>
          <div class="text">
            <p>2023年1月，本平台官方宣布：巴西传奇巨星、两届世界足球先生、世界杯冠军—罗纳尔迪尼奥正式成为本平台的形象代言人。</p>
            <p>小罗曾是巴塞罗那“梦二”时期的领军人物，2002年率领巴西国家队拿下世界杯冠军，并在2004年和2005年蝉联世界足球先生。在球场上，小罗“我即上帝”的霸气展露无遗，创造出了无数的绿茵奇迹。我们将携手重塑体育传奇，共同打造体育界的快乐“精灵”，诚邀广大球迷朋友纵享完美体验！
            </p>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="bg"><img src="/webx/xc/mobile/images/outcache/title02.a3d5.png" alt="" class="title"><img
            src="/webx/xc/mobile/images/outcache/resume.6a94.png" alt="" class="exh">
          <ul class="imgs trophys">
            <li><img src="/webx/xc/mobile/images/outcache/trophy01.0f0c.png" alt="">
              <p>美洲杯冠军</p>
            </li>
            <li><img src="/webx/xc/mobile/images/outcache/trophy02.f1aa.png" alt="">
              <p>世界杯冠军</p>
            </li>
            <li><img src="/webx/xc/mobile/images/outcache/trophy03.d4b1.png" alt="">
              <p>世界足球先生</p>
            </li>
            <li><img src="/webx/xc/mobile/images/outcache/trophy04.fff5.png" alt="">
              <p>欧洲金球奖</p>
            </li>
            <li><img src="/webx/xc/mobile/images/outcache/trophy05.f436.png" alt="">
              <p>欧洲冠军联赛冠军</p>
            </li>
          </ul>
          <div class="text">
            <div class="content">
              <h3>个人简介/introduction</h3>
              <p>中文名：罗纳尔迪尼奥 </p>
              <p>英文名：Ronaldinho</p>
              <p>昵称：小罗</p>
              <p>出生日期：1980年3月21日</p>
              <p>身高：1.82米</p>
            </div>
            <div class="content">
              <h3>个人成就/PERSONAL ACHIEVEMENT</h3>
              <p>1、美洲杯冠军</p>
              <p>2、世界杯冠军</p>
              <p>3、世界足球先生</p>
              <p>4、欧洲金球奖</p>
              <p>5、欧洲冠军联赛冠军</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zhongjian',
  data() {
    return {
      activitytypeList: [],
      actType: '',
      activitylistList: [],
    };
  },

  mounted() {
    let that = this;
    // 保存原始字体大小
    // this.originalFontSize = document.documentElement.style.fontSize

    // 设置当前页面特定的 rem 基准值 (例如 20px = 1rem)
    // document.documentElement.style.fontSize = '20px'
  },

};
</script>

<style lang="scss" scoped>

.R0MLST9LrIm3TlgIs5ln {
  height: calc(100% - .3867rem);
  box-sizing: border-box;
  overflow: auto;
  background: #f3eff9 url(/webx/xc/mobile/images/outcache/bg.9b21.jpg) no-repeat center center;
}
.R0MLST9LrIm3TlgIs5ln .top-btn {
  display: none;
  position: fixed;
  bottom: 6rem;
  right: .4rem;
  width: 2.4rem;
  height: 2.4rem;
  background: url(/webx/xc/mobile/images/outcache/icon-back-top.8799.png) no-repeat center center;
  background-size: 100% 100%;
}

.R0MLST9LrIm3TlgIs5ln .features {
  padding-bottom: .53333rem;
}

.R0MLST9LrIm3TlgIs5ln .box {
  background: rgba(249, 248, 250, .5);
  border: 1px solid #fff;
  box-shadow: 0 2.5px .75rem rgba(87, 59, 107, .15), inset 0px 0px 8.35px rgba(87, 59, 107, .15);
  border-radius: .8rem;
  margin: -0.4rem 1rem 1.4rem;
}

.R0MLST9LrIm3TlgIs5ln .box .bg {
  background: rgba(251, 250, 252, .3);
  border: 1px solid #fff;
  border-radius: .533333rem;
  text-align: center;
  margin: .53333rem;
  padding: .53333rem;
  padding-bottom: 0;
}


.R0MLST9LrIm3TlgIs5ln .box .bg .imgs {
  display: flex;
  justify-content: space-between;
  margin-top: .64rem;
}


li, em {
  list-style: none;
  font-style: normal;
}
.R0MLST9LrIm3TlgIs5ln .box .bg .imgs>li {
  width: 31%;
}


.R0MLST9LrIm3TlgIs5ln .box .bg .imgs>li>img {
  width: 100%;
}

.R0MLST9LrIm3TlgIs5ln .box .bg .text>p {
  font-size: .693333rem;
  line-height: 1.3333rem;
  text-align: left;
  color: #000;
  text-indent: 1.4rem;
  margin: .64rem 0;
}

.R0MLST9LrIm3TlgIs5ln .box {
  background: rgba(249, 248, 250, .5);
  border: 1px solid #fff;
  box-shadow: 0 2.5px .75rem rgba(87, 59, 107, .15), inset 0px 0px 8.35px rgba(87, 59, 107, .15);
  border-radius: .8rem;
  margin: -0.4rem 1rem 1.4rem;
}


.R0MLST9LrIm3TlgIs5ln .box .bg {
  background: rgba(251, 250, 252, .3);
  border: 1px solid #fff;
  border-radius: .533333rem;
  text-align: center;
  margin: .53333rem;
  padding: .53333rem;
  padding-bottom: 0;
}

.R0MLST9LrIm3TlgIs5ln .box .bg .trophys {
  background: #e2e0ef;
  border: 1px solid #f2f3fa;
  box-shadow: 4px 4px 1rem rgba(87, 59, 107, .1);
  border-radius: .53333rem;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: 1.2rem;
}


.R0MLST9LrIm3TlgIs5ln .box .bg .trophys>li {
  position: relative;
}
.R0MLST9LrIm3TlgIs5ln .box .bg .imgs>li {
  width: 31%;
}
.R0MLST9LrIm3TlgIs5ln .box .bg .imgs>li>img {
  width: 100%;
}

.R0MLST9LrIm3TlgIs5ln .box .bg .trophys>li>img {
  width: auto;
}



.R0MLST9LrIm3TlgIs5ln .box .bg .text .content {
  text-align: left;
  margin: 1rem 0;
  text-transform: uppercase;
}


.R0MLST9LrIm3TlgIs5ln .box .bg .text .content>h3 {
  font-size: .85333rem;
  font-weight: 400;
  margin-bottom: .4rem;
}


.R0MLST9LrIm3TlgIs5ln .box .bg .text .content>p {
  line-height: 1.4rem;
}

  .R0MLST9LrIm3TlgIs5ln .box .bg .text .content {
    text-align: left;
    margin: 1rem 0;
    text-transform: uppercase;
  }

.R0MLST9LrIm3TlgIs5ln .box .bg .title {
  width: 8.4rem;
  margin-top: -1rem;
}
.R0MLST9LrIm3TlgIs5ln .features .barner {
  width: 100%;
}


.R0MLST9LrIm3TlgIs5ln .features .top-title {
  margin: auto;
  display: block;
  width: 18.2rem;
  margin-top: -1rem;
}

.R0MLST9LrIm3TlgIs5ln .box .bg .exh {
  width: 100%;
  height: 9rem;
  margin-top: .8rem;
  border: none;
}


.R0MLST9LrIm3TlgIs5ln .box .bg .trophys>li>img {
  width: auto;
}

.R0MLST9LrIm3TlgIs5ln .box .bg .trophys>li>p {
  margin-top: .4rem;
  white-space: nowrap;
  font-size: 12px;
}

.R0MLST9LrIm3TlgIs5ln .box .bg .text .content>h3 {
  font-size: .85333rem;
  font-weight: 200;
  margin-bottom: .4rem;
}

.R0MLST9LrIm3TlgIs5ln .box .bg .text .content>p {
  line-height: 1.4rem;
  font-size: 12px;
}
</style>